export default __webpack_public_path__ + "media/images/supplied/spiralStaircase-6e2fe6007645f5cdba9a554423b64aa7.jpg";